module.exports = __webpack_public_path__ + "static/media/02.e175e772.png";